export const Title = ({ children, className }) => {
  return (
    <h1 className={`m-0 p-0 ${className}`}>{children || "placeholder"}</h1>
  );
};
